import React, { useLayoutEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'

import reportWebVitals from './reportWebVitals'

import App from './App'

import Home from './pages/Home'
import Video from './pages/Video'
import Playlist from './pages/Playlist'
import SearchResults from './pages/SearchResults'
import Profile from './pages/Profile'
import Settings from './pages/Settings'
import Error from './pages/Error'

const ScrollTopWrapper = ({ children }) => {
  const location = useLocation()

  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0)
  }, [location.pathname])

  return children
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollTopWrapper>
        <App>
          <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="video/:videoID" element={<Video/>}/>
            <Route path="playlist/:playlistID" element={<Playlist/>}/>
            <Route path="search/:query" element={<SearchResults/>}/>
            <Route path="profile/" element={<Profile/>}/>
            <Route path="settings/" element={<Settings/>}/>
            <Route path="*" element={<Error/>}/>
          </Routes>
        </App>
      </ScrollTopWrapper>
    </BrowserRouter>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
